/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
      let addText = theme.strings.addToCart;
      let preorderText = theme.strings.preOrder;
      let soldOutText = theme.strings.soldOut;
      const saleTypeText = theme.strings.saleType;
      const add_to_cart_btn = document.querySelector('[data-add-to-cart]');
      const preorder_input = document.querySelector('[data-product-preorder]');

      const preorder_input_container = `<input type="hidden" data-product-preorder name="properties[${saleTypeText}]" value="${preorderText}">`

      //method to format the price with currency. For example, the price is 9000 and it should be € 90.00
      const price = formatMoney(variant.price, window.theme.moneyFormat);

      // if variant is sold out, change the text of add to cart button
      if(variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0) {
        // select item with data-add-to-cart attribute
        add_to_cart_btn.innerHTML = `${preorderText} <span class="cta__dot">•</span> ${price}`;
        if(!preorder_input) {
          document.querySelector('.product__submit').insertAdjacentHTML('beforeend', preorder_input_container);
        }
      }
      else if(variant.inventory_quantity === 0) {
        add_to_cart_btn.innerHTML = `${soldOutText} <span class="cta__dot">•</span> ${price}`;
        if(preorder_input) {
          preorder_input.remove();
        }
      }
      else {
        add_to_cart_btn.innerHTML = `${addText} <span class="cta__dot">•</span> ${price}`;
        if(preorder_input) {
          preorder_input.remove();
        }
      }
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  const gift_wrapping = document.querySelector('#gift-wrapping-checkbox');
  const gift_wrapping_input = document.querySelector('#requires-gift-wrapping');
  // get the value of gift wrapping checkbox
  gift_wrapping.addEventListener('change', (e) => {
    const is_checked = e.target.checked;
    //assign the value of is_checked to gift_wrapping_input
    gift_wrapping_input.value = is_checked;
  })

  const engraving_input = document.querySelector('#engraving');
  const engraving_field = document.querySelector('#engraving_field');

 if(engraving_input) {
   engraving_input.addEventListener('change', (e) => {
     engraving_field.value = e.target.value;
   });
 }

 const codice_fiscale = document.querySelector('#input-codice-fiscale');
 const checkout_button = document.querySelector('#cart-page-checkout');
 const cart_button_helper = document.querySelector('.missing_codice_fiscale');

 if(codice_fiscale) {  
   codice_fiscale.addEventListener('keyup', (e) => {
    const codice_fiscale_value = e.target.value;
    const formatted_codice_fiscale_value = codice_fiscale_value.replace(/\s/g, '');

    if(formatted_codice_fiscale_value !== '') {
      checkout_button.disabled = false;
      cart_button_helper.style.display = 'none';
    }
    else {
      checkout_button.disabled = true;
      cart_button_helper.style.display = 'block';
    }
  })
 }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

const formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};